import { render, staticRenderFns } from "./gamblers-rank.vue?vue&type=template&id=db7bc6f0&scoped=true&"
import script from "./gamblers-rank.vue?vue&type=script&lang=js&"
export * from "./gamblers-rank.vue?vue&type=script&lang=js&"
import style0 from "./gamblers-rank.vue?vue&type=style&index=0&id=db7bc6f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7bc6f0",
  null
  
)

export default component.exports